import { CandidateState, CandidateEditStatus } from '../../_generatedTypes.g';
import { getCandidateById } from '../../selectors';
import { api, ReadAs } from '../../api';
import { UnknownAction, Dispatch } from 'redux';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { candidateReplaced } from './candidatesSlice';

export const startEditingParty = (candidateId: number, candidates: CandidateState[], dispatch: Dispatch<UnknownAction>) => {
    const candidate = getCandidateById(candidates, candidateId);
    dispatch(editingCandidateStarted(candidate));
}

export const saveCandidate = async (candidate: CandidateState, token : string, dispatch: Dispatch<UnknownAction>) => {
    dispatch(candidateEditStatusChanged({candidate: candidate, editStatus: CandidateEditStatus.Saving }));

    return await api(token).Candidates.Update<void>(candidate)
        .ok((json: { RowVersion: string }) => {
            const updatedCandidateWithRowVersion = { ...candidate, RowVersion: json.RowVersion };
            dispatch(candidateEdited({candidateId: candidate.CandidateId, candidateChanges: { RowVersion: json.RowVersion }}));
            dispatch(candidateEditStatusChanged({candidate: candidate, editStatus: CandidateEditStatus.Success}));
            dispatch(candidateReplaced(updatedCandidateWithRowVersion));
        }, ReadAs.Json)
        .anyStatus(errors => {
            dispatch(candidateEdited({candidateId: candidate.CandidateId, candidateChanges: { ModelErrors: errors }}));
            dispatch(candidateEditStatusChanged({candidate: candidate, editStatus: CandidateEditStatus.Error}));
        }, ReadAs.ValidationErrors)
        .fail(() => dispatch(candidateEditStatusChanged({candidate: candidate, editStatus:  CandidateEditStatus.Error})))
};

export type CandidateById = { [candidateId: number]: CandidateState };

const candidateEditSlice = createSlice({
    name: 'SLICE_candidateEdit',
    initialState: {}  as CandidateById,
    reducers: {
        editingCandidateStarted(state, action: PayloadAction<CandidateState>) {
            const id = action.payload.CandidateId;
            return {
                ...state,
                [id]: {
                    ...action.payload,
                    EditStatus: undefined,
                }
            };
        },
        candidateEdited(state, action: PayloadAction<{ candidateId: number, candidateChanges: Partial<CandidateState> }>) {
            const id = action.payload.candidateId;
            return {
                ...state,
                [id]: {
                    ...state[id],
                    ...action.payload.candidateChanges,
                    EditStatus: undefined,
                }
            };  
            },
        candidateEditStatusChanged(state, action: PayloadAction<{candidate: CandidateState, editStatus: CandidateEditStatus}>) {
            const id = action.payload.candidate.CandidateId;
            return {
                ...state,
                [id]: {
                    ...state[id],
                    ...action.payload,
                    EditStatus: action.payload.editStatus,
                }
            };         },
       
    },
})

export const {
    editingCandidateStarted,
    candidateEdited,
    candidateEditStatusChanged,
} = candidateEditSlice.actions

export default candidateEditSlice.reducer
